import { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId: string) => {
    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    } else {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
    setIsMobileMenuOpen(false);
  };

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
    }`}>
      <div className="max-w-7xl mx-auto px-6 lg:px-20">
        <div className="flex items-center justify-between h-24">
          <Link to="/" className="flex items-center">
            <img 
              src="https://static.readdy.ai/image/4b461963755593d5c146d3f2bf08aa37/75a4d8bef836f74aa5a9f6172d661df5.jpeg" 
              alt="David Nieves Art Gallery" 
              className="h-20 w-auto"
            />
          </Link>

          <div className="hidden md:flex items-center space-x-8">
            <button 
              onClick={() => scrollToSection('home')}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-800 hover:text-[#e8a65b]' : 'text-white hover:text-[#e8a65b]'
              }`}
            >
              Inicio
            </button>
            <button 
              onClick={() => scrollToSection('gallery')}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-800 hover:text-[#e8a65b]' : 'text-white hover:text-[#e8a65b]'
              }`}
            >
              Galería
            </button>
            <button 
              onClick={() => scrollToSection('shop')}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-800 hover:text-[#e8a65b]' : 'text-white hover:text-[#e8a65b]'
              }`}
            >
              Tienda
            </button>
            <button 
              onClick={() => scrollToSection('instagram')}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-800 hover:text-[#e8a65b]' : 'text-white hover:text-[#e8a65b]'
              }`}
            >
              Instagram
            </button>
            <button 
              onClick={() => scrollToSection('about')}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-800 hover:text-[#e8a65b]' : 'text-white hover:text-[#e8a65b]'
              }`}
            >
              Sobre Mí
            </button>
            <button 
              onClick={() => scrollToSection('contact')}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-800 hover:text-[#e8a65b]' : 'text-white hover:text-[#e8a65b]'
              }`}
            >
              Contacto
            </button>
          </div>

          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className={`md:hidden p-2 cursor-pointer ${
              isScrolled ? 'text-gray-800' : 'text-white'
            }`}
          >
            <i className={`ri-${isMobileMenuOpen ? 'close' : 'menu'}-line text-2xl`}></i>
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-white shadow-lg">
          <div className="px-6 py-4 space-y-3">
            <button 
              onClick={() => scrollToSection('home')}
              className="block w-full text-left text-sm font-medium text-gray-800 hover:text-[#e8a65b] py-2 cursor-pointer"
            >
              Inicio
            </button>
            <button 
              onClick={() => scrollToSection('gallery')}
              className="block w-full text-left text-sm font-medium text-gray-800 hover:text-[#e8a65b] py-2 cursor-pointer"
            >
              Galería
            </button>
            <button 
              onClick={() => scrollToSection('shop')}
              className="block w-full text-left text-sm font-medium text-gray-800 hover:text-[#e8a65b] py-2 cursor-pointer"
            >
              Tienda
            </button>
            <button 
              onClick={() => scrollToSection('instagram')}
              className="block w-full text-left text-sm font-medium text-gray-800 hover:text-[#e8a65b] py-2 cursor-pointer"
            >
              Instagram
            </button>
            <button 
              onClick={() => scrollToSection('about')}
              className="block w-full text-left text-sm font-medium text-gray-800 hover:text-[#e8a65b] py-2 cursor-pointer"
            >
              Sobre Mí
            </button>
            <button 
              onClick={() => scrollToSection('contact')}
              className="block w-full text-left text-sm font-medium text-gray-800 hover:text-[#e8a65b] py-2 cursor-pointer"
            >
              Contacto
            </button>
          </div>
        </div>
      )}
    </nav>
  );
}